import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { AddPayrocTerminalAccountPayload } from './addPayrocTerminalAccount';

export interface IndividualPayrocTerminalAccount {
  terminalId: string;
  id: number;
  storeId: number;
  payrocMerchantAccountId: number;
}

export interface EditPayrocTerminalAccountPayload extends AddPayrocTerminalAccountPayload {
  payrocTerminalAccountId: number;
}

export const editPayrocTerminalAccount = ({
  terminalId,
  payrocTerminalAccountId,
  payrocMerchantAccountId,
  storeId,
}: EditPayrocTerminalAccountPayload): AxiosPromise<IndividualPayrocTerminalAccount> => {
  return httpClient({
    method: 'PATCH',
    url: `/super-admin/stores/${storeId}/payroc/terminals/update`,
    data: {
      terminalId,
      payrocTerminalAccountId,
      payrocMerchantAccountId,
    },
  });
};
